interface PropsLabel {
    title: string
}

export function Label({ title }: PropsLabel) {
    return (
        <label className="block text-sm text-gray-800 font-semibold">{title}</label>
    )
}